import { ROLE_TYPES } from "~/constans/roles";

type CheckAccessParams = {
  allowedRoles: string[];
  role: string;
  access: string[];
};

export const checkStatusAccess = ({
  allowedRoles,
  role,
  access,
}: CheckAccessParams) => {
  /**
   * Если список разрешенных ролей пуст, доступ запрещен
   */
  if (!allowedRoles.length) {
    return false;
  }

  /**
   * Если текущая роль входит в список разрешенных ролей, доступ разрешен
   */
  if (allowedRoles.includes(role)) {
    return true;
  }

  /**
   *  Если текущая роль - ADMIN, доступ разрешен
   */
  if (role === ROLE_TYPES.ADMIN.name) {
    return true;
  }

  /**
   * Если текущая роль - ADMIN_DATA и есть доступ isEmployeeAccess, доступ разрешен
   */
  if (
    role === ROLE_TYPES.ADMIN_DATA.name &&
    access.includes("isEmployeeAccess")
  ) {
    return true;
  }

  /**
   * В остальных случаях доступ запрещен
   */
  return false;
};
